export default "__VITE_ASSET__DuJZgqS4__"